import { School } from '@mui/icons-material';
import { IconButton } from '@mui/material';

const columns = {
    seguimiento: (idReporte, idSesion, data, option) => {
        let head = [];
        switch (idReporte) {
            // REPORTE DE CALIFICACIONES
            case 1:
                if (idSesion == 0 || idSesion == null)
                    head = [
                        { label: 'Sesión', name: 'NomSesion', filtrar: true },
                        { label: 'Actividad', name: 'nactividad', filtrar: true },
                        { label: 'Calificación', name: 'calificacion', filtrar: true }
                    ];
                else {
                    let keys = data?.length > 0 ? Object.keys(data[0]?.temarios || {}) : [];
                    keys.forEach((key) => {
                        head.push({ label: key, name: key, filtrar: true });
                    });
                }
                break;
            //REPORTE GLOBAL PROGRESO
            case 2:
                head = [
                    { label: 'Progreso', name: 'progreso', type: { opcion: 'numero', accion: 'percent' }, filtrar: true },
                    { label: 'Promedio', name: 'promedio', type: { opcion: 'numero' }, filtrar: true },
                    { label: 'Estatus', name: 'estatus', filtrar: true },
                    { label: 'Curso', name: 'titulo', filtrar: true }
                ];
                break;
            //REPORTE REGISTRADOS
            case 3:
                head = [
                    { label: 'DIRECCIÓN', name: 'direccion', filtrar: true },
                    { label: 'CP', name: 'cp', filtrar: true },
                    { label: 'COLONIA', name: 'colonia', filtrar: true },
                    { label: 'MUNICIPIO', name: 'municipio', filtrar: true },
                    { label: 'ESTADO', name: 'estado', filtrar: true },
                    { label: 'TELEFONO', name: 'telefono1', filtrar: true },
                    { label: 'EMAIL', name: 'email_personal', filtrar: true },
                    { label: 'EMAIL EMPRESA', name: 'email_empresarial', filtrar: true }
                ];
                break;
            //REPORTE DE GRUPOS
            //REPORTE DE CURSOS
            case 4:
                head = [
                    { label: option == 1 ? 'CURSO' : 'GRUPO', name: 'nombre_grupo', filtrar: true },
                    { label: 'Sesión', name: 'titulo', filtrar: true },
                    { label: 'Promedio', type: { opcion: 'numero', accion: 'cantidad' }, name: 'Promedio', filtrar: true },
                    { label: 'Progreso', type: { opcion: 'numero', accion: 'percent' }, name: 'progreso', filtrar: true }
                ];
                break;
            //REPORTE DE FINALIZACIÓN
            case 5:
                head = [
                    { label: 'Fecha Fin', name: 'fechaFin', type: { opcion: 'date', accion: 1 }, filtrar: true },
                    { label: 'Estatus', name: 'estatus', filtrar: true },
                    { label: 'Curso', name: 'titulo', filtrar: true }
                ];
                break;
            //REPORTE ADMINISTRATIVO
            case 6:
                head = [
                    { label: 'Nom Video', name: 'ultimoVideo', filtrar: true },
                    { label: 'Estatus', name: 'estatus', filtrar: true },
                    { label: 'Promedio', name: 'promedio', filtrar: true }
                ];
                break;
            case 7:
                head = [
                    { label: 'Fecha habilitación', name: 'fecha_ingreso', filtrar: true }, // fecha_ingreso
                    { label: 'Primera interacción', name: 'primerAcceso', filtrar: true }, // tbl_acceso
                    { label: 'Última interacción', name: 'ultimoAcceso', filtrar: true }, // tbl_acceso
                    { label: 'Cursos habilitados', name: 'totalCursos', filtrar: true },
                    { label: 'Cursos completados', name: 'aprobados', filtrar: true }
                ];
                break;
            default:
                break;
        }

        head = [
            { label: 'Num. Empleado', name: 'num_empleado', filtrar: true },
            { label: 'Nombre', name: 'nombre_persona', filtrar: true },
            { label: 'Puesto', name: 'nom_puesto', filtrar: true },
            { label: 'Estatus empleado', name: 'estatus_vacante', filtrar: true },
            { label: 'Departamento', name: 'nom_area', filtrar: true },
            { label: 'Área', name: 'nom_subarea', filtrar: true },
            { label: 'Sede', name: 'nom_sede', filtrar: true },

            // { label: 'CURP', name: 'CURP', filtrar: true },
            ...head
        ];

        return head;
    }
};

export default columns;
